<script>
// @ is an alias to /src
import Layout from "@/layout/Main.vue";

export default {
	components: {
		Layout
	},

	data () {
		return {
		  publicPath: process.env.BASE_URL,

		  token: "",
		  device_token: "",

		  	marker: { position: { lat: null, lng: null } },
         center: { lat: null, lng: null },
         current_place: null,
         location: "",

         mapOptions: {
            disableDefaultUI: true,
         },

         payment_method: 1,
         delivery_notes: '',
         offer_code: '',
         branch_id: '',
         no_Cutlery: 0,
         delivery_date: '',
         delivery_time: '',
         delivery_type: 'DoorDelivery',
         delivery_charge: '',
         service_charge: '',
         subtotal: '',
         grandtotal: '',
         block_no: '',
         contactless: 0,
		 sub_total: '',

         cart: {},
         address: {},
		 address_id: '',
		 place_order: false,
		 addresses: [],
		 guestAddresses: [],

		}
	},
	mounted() {

		let style = document.createElement('link')
		style.setAttribute('rel', 'stylesheet')
		style.setAttribute('href', '/design/checkout.css')
		document.head.appendChild(style)
	},

	created() {
		this.getLocation();
		this.fetchCheckoutData();
		this.fetchRestaurant();
	},

	methods: {
		getToken() {
			if (localStorage.getItem('sigofood_user')) {
				var sigofood_user =  JSON.parse(localStorage.getItem('sigofood_user'));
				console.log(sigofood_user);
				if(sigofood_user.token) {
					this.token = sigofood_user.token;
					this.uid = sigofood_user.uid;
					this.user_id = sigofood_user.user_id;

				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}
				
			} else if(localStorage.getItem('sigofood_guest')){
				var sigofood_guest =  JSON.parse(localStorage.getItem('sigofood_guest'));
				console.log(sigofood_guest);
				if(sigofood_guest.token) {
					this.guestToken = sigofood_guest.token;
					this.guest_id = sigofood_guest.guest_id;
					this.uid = "";

				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}
			}else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
			}
      	}, 


		fetchCheckoutData() {
			if (localStorage.getItem('promotion_checkout_data')) {
				var promotion_checkout_data =  JSON.parse(localStorage.getItem('promotion_checkout_data'));
				console.log(promotion_checkout_data);
				this.products = promotion_checkout_data.products;
				this.branch_id = promotion_checkout_data.branch_id;
				this.promotion_id = promotion_checkout_data.pr_id;
				this.rest_id = promotion_checkout_data.r_id;
				this.restaurant = promotion_checkout_data.restaurant;
				this.subtotal = promotion_checkout_data.subtotal;

				console.log(this.products);
				console.log(this.promotion_id);
				console.log(this.rest_id);
			}
		},

		getLocation() {
			if (localStorage.getItem('sigofood_location')) {
				var sigofood_location =  JSON.parse(localStorage.getItem('sigofood_location'));
				if(sigofood_location.block_no) {
					this.block_no = sigofood_location.block_no;
					console.log(this.block_no);
				} 
			}  else {
				this.$router.push({ name: "location" });
			}
		}, 

		showModal(modal) {
         this.$refs[modal].show();
		},

		hideModal(modal) {
			this.$refs[modal].hide();
		}, 

		chooseAddress() {
			this.getToken();
			if(this.uid) {
				if(localStorage.getItem('sigofood_uid')) {
					this.uid = localStorage.getItem('sigofood_uid');  
				} 

				const config = {
					headers: {
						"Content-type": "multipart/form-data",
						"Accept": "application/json",
						"Authorization": "Bearer " + this.token,

					},
				};

				let url = "address?uid=" + this.uid + "&device_token=" + this.uid;          
						
						this.$axios
							.get(url, config)
							.then((res) => {
								if(res.status == 200) {
									var responseData = res.data;
									console.log(responseData);
									this.addresses = responseData.data;
								
									console.log(this.addresses);
									this.showModal("address-modal");
									
								} else {
									this.$swal("", "Something went wrong", "error");
								}                  
						})
						.catch((error) => {
							if (error.response) {
								if(error.response.status == 422) {               
									if (error.response.data) {
									this.errors = error.response.data.message;
									} 
									this.$swal("", error.response.statusText, "error");
									
								} else if(error.response.status == 500) {
									this.$swal("", error.response.statusText, "error");

								} else if(error.response.status == 401) {
									this.$swal("", error.response.statusText, "error");
									this.$router.push({ name: "login" });
									
								} else {
									this.$swal("", "Something went wrong", "error");
								}
							} else {
								this.$swal("", error.message, "error");
							}
						})
						.finally(() => (this.loading = false));
			} else {
				const config = {
					headers: {
						"Content-type": "multipart/form-data",
						"Accept": "application/json",
						"Authorization": "Bearer ",
					},
				};

				let url = "address?uid=" + this.guestToken + "&device_token=" + this.guestToken;   

						
				this.$axios
					.get(url, config)
					.then((res) => {
							if(res.status == 200) {
								var responseData = res.data;
								console.log(responseData);
								this.guestAddresses = responseData.data;

								console.log(this.guestAddresses);
								this.showModal("address-modal");

							} else {
								this.$swal("", "Something went wrong", "error");
							} 
									
						})
						.catch((error) => {
							if (error.response) {
								if(error.response.status == 422) {               
									if (error.response.data) {
										this.errors = error.response.data.message;
									} 
									this.$swal("", error.response.statusText, "error");
										
								} else if(error.response.status == 500) {
									this.$swal("", error.response.statusText, "error");
									
								} else if(error.response.status == 401) {
									this.$swal("", error.response.statusText, "error");
									this.$router.push({ name: "login" });
										
								} else {
									this.$swal("", "Something went wrong", "error");
								}
							} else {
								this.$swal("", error.message, "error");
							}
						})
					.finally(() => (this.loading = false));
			}	 			
      	}, 

		checkAddress(address_id) {
			this.hideModal("address-modal");

			this.getToken();
			if(this.uid) {
				if(localStorage.getItem('sigofood_uid')) {
					this.uid = localStorage.getItem('sigofood_uid');  
				} 
				const config = {
					headers: {
						"Content-type": "multipart/form-data",
						"Accept": "application/json",
						"Authorization": "Bearer " + this.token,

					},
				};
				let url = "delivery/checkAddress"; 

				let formData = new FormData();
				formData.append("uid", this.uid);
				formData.append("device_token", this.uid);
				formData.append("address_id", address_id);
				formData.append("branch_id", this.branch_id);
				formData.append("restaurant_id", this.rest_id);
				formData.append("block_no", this.block_no);

				this.$axios
					.post(url, formData, config)
					.then((res) => {
						if(res.status == 200) {
							var responseData = res.data;
							console.log(responseData);
							this.message = responseData.message;
							
							if(responseData.status == true) {
								console.log("correct");
								this.fetchAddress(address_id);
							} else {
								alert(this.message);
								this.$swal("", responseData.message, );
							}
									
						} else {
							this.$swal("", "Something went wrong", "error");
						}                  
					})
					.catch((error) => {
						if (error.response) {
							if(error.response.status == 422) {               
								if (error.response.data) {
									this.errors = error.response.data.message;
								} 
								this.$swal("", error.response.statusText, "error");
									
							} else if(error.response.status == 500) {
								this.$swal("", error.response.statusText, "error");

							} else if(error.response.status == 401) {
								this.$swal("", error.response.statusText, "error");
								this.$router.push({ name: "login" });
									
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", error.message, "error");
						}
					})
					.finally(() => (this.loading = false));
			
			} else {
				const config = {
					headers: {
						"Content-type": "multipart/form-data",
						"Accept": "application/json",
						"Authorization": "Bearer ",
					},
				};

				let url = "delivery/checkAddress"; 

				let formData = new FormData();
				formData.append("uid", this.guestToken);
				formData.append("device_token", this.guestToken);
				formData.append("address_id", address_id);
				formData.append("branch_id", this.branch_id);
				formData.append("restaurant_id", this.rest_id);
				formData.append("block_no", this.block_no);

				this.$axios
					.post(url, formData, config)
					.then((res) => {
						if(res.status == 200) {
							var responseData = res.data;
							console.log(responseData);
							this.message = responseData.message;
							if(responseData.status == true) {
								console.log("correct");
								this.fetchAddress(address_id);
							} else {
								alert(this.message);
								this.$swal("", responseData.message, );
							}
								
						} else {
							this.$swal("", "Something went wrong", "error");
						}                  
				})
				.catch((error) => {
					if (error.response) {
						if(error.response.status == 422) {               
							if (error.response.data) {
							this.errors = error.response.data.message;
							} 
							this.$swal("", error.response.statusText, "error");
							
						} else if(error.response.status == 500) {
							this.$swal("", error.response.statusText, "error");

						} else if(error.response.status == 401) {
							this.$swal("", error.response.statusText, "error");
							this.$router.push({ name: "login" });
							
						} else {
							this.$swal("", "Something went wrong", "error");
						}						} else {
							this.$swal("", error.message, "error");
					}
				})
				.finally(() => (this.loading = false));

			}   
		},


		fetchAddress(address_id) {
			
			this.getToken();

			if(this.uid) {
				if(localStorage.getItem('sigofood_uid')) {
					this.uid = localStorage.getItem('sigofood_uid');  
				} 

				const config = {
					headers: {
						"Content-type": "multipart/form-data",
						"Accept": "application/json",
						"Authorization": "Bearer " + this.token,

					},
				};

				let url = "address/details?address_id=" + address_id + "&uid=" + this.uid + "&device_token=" + this.device_token;          
				this.loading = true;

				this.$axios
					.get(url, config)
					.then((res) => {
						console.log(res);
					if(res.status == 200) {
						var responseData = res.data.data;
						console.log(responseData);

						this.address = responseData;
						console.log(this.address);
							this.latitude = this.address.latitude;
							this.longitude = this.address.longitude;
							console.log(this.latitude);
							console.log(this.longitude);
							this.marker.position.lat = parseFloat(responseData.latitude);
							this.marker.position.lng = parseFloat(responseData.longitude);

							this.center.lat = parseFloat(responseData.latitude);
							this.center.lng = parseFloat(responseData.longitude);

					} else {
						this.$swal("", "Something went wrong", "error");
					}
					
				})
				.catch((error) => {
					if (error.response) {
					if(error.response.status == 422) {               
						if (error.response.data) {
							this.errors = error.response.data.message;
						} 
						this.$swal("", error.response.statusText, "error");
						
					} else if(error.response.status == 500) {
						this.$swal("", error.response.statusText, "error");

					} else if(error.response.status == 401) {
						this.$swal("", error.response.statusText, "error");
						this.$router.push({ name: "login" });
						
					} else {
						this.$swal("", "Something went wrong", "error");
					}
					} else {
					this.$swal("", error.message, "error");
					}
				})
				.finally(() => (this.loading = false));

			} else {
				const config = {
					headers: {
						"Content-type": "multipart/form-data",
						"Accept": "application/json",
						"Authorization": "Bearer ",
					},
				};

				let url = "address/details?address_id=" + address_id + "&uid=" + this.guestToken + "&device_token=" + this.guestToken;          
				this.loading = true;

				this.$axios
					.get(url, config)
					.then((res) => {
						console.log(res);
					if(res.status == 200) {
						var responseData = res.data.data;
						console.log(responseData);

						this.address = responseData;
						console.log(this.address);
							this.latitude = this.address.latitude;
							this.longitude = this.address.longitude;
							console.log(this.latitude);
							console.log(this.longitude);
							console.log("hi");
							this.marker.position.lat = parseFloat(responseData.latitude);
							this.marker.position.lng = parseFloat(responseData.longitude);

							this.center.lat = parseFloat(responseData.latitude);
							this.center.lng = parseFloat(responseData.longitude);

					} else {
						this.$swal("", "Something went wrong", "error");
					}
					
				})
				.catch((error) => {
					if (error.response) {
					if(error.response.status == 422) {               
						if (error.response.data) {
							this.errors = error.response.data.message;
						} 
						this.$swal("", error.response.statusText, "error");
						
					} else if(error.response.status == 500) {
						this.$swal("", error.response.statusText, "error");

					} else if(error.response.status == 401) {
						this.$swal("", error.response.statusText, "error");
						this.$router.push({ name: "login" });
						
					} else {
						this.$swal("", "Something went wrong", "error");
					}
					} else {
					this.$swal("", error.message, "error");
					}
				})
				.finally(() => (this.loading = false));

			}		
      	}, 

		getMapUrl() {
            return `https://maps.google.com/maps?q=${this.latitude},${this.longitude}&z=15&output=embed`;
        },


		fetchRestaurant() {

			const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,

               },
            };
				let url = "restaurant/details";          
				let formData = new FormData();
				formData.append("restaurant_id",this.rest_id);
				formData.append("branch_id", this.branch_id );

				this.$axios
					.post(url,formData, config)
					.then((res) => {
						if(res.status == 200) {
							var responseData = res.data.data;
							
							this.restaurant = responseData.restaurant;
							this.delivery_charge = this.restaurant.delivery_charge;
							this.service_charge = this.restaurant.service_charge;
							console.log(this.restaurant);
							console.log(this.delivery_charge);
								
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					
				})
				.catch((error) => {
					if (error.response) {
						if(error.response.status == 422) {               
							if (error.response.data) {
							this.errors = error.response.data.message;
							} 
							this.$swal("", error.response.statusText, "error");
							
						} else if(error.response.status == 500) {
							this.$swal("", error.response.statusText, "error");

						} else if(error.response.status == 401) {
							this.$swal("", error.response.statusText, "error");
							this.$router.push({ name: "login" });
							
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					} else {
						this.$swal("", error.message, "error");
					}
				})
				.finally(() => (this.loading = false));

		},

        changeContactless() {
            if(this.contactless == '1') {
                this.payment_method = 0;
            } else {
                this.payment_method = 1;
            }
        },

        changeCash() {
            alert(this.contactless);
            if(this.contactless == '1') {
                this.payment_method = 0;
            } 
        },

		
      	promotionCheckout() {
            this.getToken();           
	        var config;
			var grandtotal = this.subtotal;
            if(this.delivery_type == 'DoorDelivery') {
            	grandtotal = parseFloat(grandtotal) + parseFloat(this.delivery_charge);
            }
			console.log(this.products);
            if(this.uid) {
	            config = {
	               headers: {
	                  "Content-type": "multipart/form-data",
	                  "Accept": "application/json",
	                  "Authorization": "Bearer " + this.token,
	               },
	            };
				let url = "promotions/checkout";
				let formData = new FormData();
				formData.append("device_token", this.uid); 
                formData.append("promotion_id", this.promotion_id); 
				formData.append("address_id", this.address.address_id);
				formData.append("r_id", this.rest_id); 
				formData.append("payment_method", this.payment_method); 
				formData.append("delivery_notes", this.delivery_notes); 
				formData.append("branch_id", this.branch_id); 
				formData.append("products", JSON.stringify(this.products));
                formData.append("delivery_type", this.delivery_type);
				formData.append("delivery_date", this.delivery_date); 
				formData.append("delivery_time", this.delivery_time); 
				 
				formData.append("delivery_charge", this.delivery_charge); 
				formData.append("service_charge", this.service_charge);
				formData.append("total", this.subtotal); 
				formData.append("subtotal", this.subtotal); 
				formData.append("grandtotal", grandtotal);
				formData.append("block_no", this.block_no);
			

				this.$axios
				.post(url, formData, config)
				.then((response) => {
					if (response.data.status==true) {
							this.$swal("", response.data.message, "success");
							this.$router.push({ name: 'orders'});
					} else if(response.data.status==false){
							this.$swal("", response.data.message, "Failed");
							this.$router.push({ name: 'cart'});
					} else {
						this.$swal("", response.data.message, "error");
						this.$router.push({ name: 'home'});
            		}
                 
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));

			} else {
				config = {
	               headers: {
	                  "Content-type": "multipart/form-data",
	                  "Accept": "application/json",
	                  "Authorization": "Bearer ",
	               },
	            };
				let url = "promotions/checkout";
				let formData = new FormData();
				formData.append("device_token", this.guestToken); 
                formData.append("promotion_id", this.promotion_id); 
				formData.append("address_id", this.address.ga_id);
				formData.append("r_id", this.rest_id); 
				formData.append("payment_method", this.payment_method); 
				formData.append("delivery_notes", this.delivery_notes); 
				formData.append("branch_id", this.branch_id); 
				formData.append("products", JSON.stringify(this.products));
                formData.append("delivery_type", this.delivery_type);
				formData.append("delivery_date", this.delivery_date); 
				formData.append("delivery_time", this.delivery_time); 
				 
				formData.append("delivery_charge", this.delivery_charge); 
				formData.append("service_charge", this.service_charge);
				formData.append("total", this.subtotal); 
				formData.append("subtotal", this.subtotal); 
				formData.append("grandtotal", grandtotal);
				formData.append("block_no", this.block_no);
			

				this.$axios
				.post(url, formData, config)
				.then((response) => {
					if (response.data.status==true) {
							this.$swal("", response.data.message, "success");
							this.$router.push({ name: 'orders'});
					} else if(response.data.status==false){
							this.$swal("", response.data.message, "Failed");
							this.$router.push({ name: 'cart'});
					} else {
						this.$swal("", response.data.message, "error");
						this.$router.push({ name: 'home'});
            		}
                 
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
			}   
			
		},		

	}
}
</script>


<template>
	<Layout>
		<div class="container-sm page"><br>
			<form @submit.prevent="promotionCheckout">
				<div class="container order">
					<div class="row">
						<div class="col">
							<h4 class="order-summary">Order Summary</h4>
						</div>
						<div class="col text-end edit-order">
							<router-link :to="{ name: 'offers' }" class="btn btn-warning me btn-sm">Edit order</router-link>
						</div>
					</div>
				</div>
				<div class="container items" v-if="products.length">
					<h5 class="diary-queen">{{restaurant.rest_name}}</h5><br>
					<div class="row item">
						<div class="col">
							<p class="fw-semibold">Item(s)</p>
						</div>
						<div class="col">
							<p class="fw-semibold">Offer</p>
						</div>
						<!-- <div class="col">
							<p class="fw-semibold">Qty</p>
						</div> -->
						<div class="col">
							<p class="fw-semibold">Price</p>
						</div>
						<div class="col">
							<p class="fw-semibold">Total</p>
						</div>
					</div>
					<div class="row item" v-for="(product) in products" :key="product.product_id">
						<div class="col">
							<p class="fw-semibold">{{product.product_name_english}}
							</p>
						</div>
						<div class="col">
							<!-- <p>{{product.price}}</p> -->
						</div>
						<!-- <div class="col">
							<p>{{item.quantity}}</p>
						</div> -->
						<div class="col">
							<p>BHD {{product.price}}</p>
						</div>
						<div class="col">
							<p>BHD {{product.price}}</p>
						</div>
					</div>
				</div>
				<div class="container cultery">
					
					<b-form-checkbox
				      id="chk-no-cutlery"
				      v-model="no_Cutlery"
				      name="chk-no-cutlery"
				      value="1"
				      unchecked-value="0"
				      class = "no-cultery"
				   >
				      <span class="ms-1">No Cultery</span>
				   </b-form-checkbox>
				</div><br>

				<div class="">
					<div class="row">
						<div class="col-1 text-end">
							<img src="/design/sigofood-images/notes.png">
						</div>
						<div class="col">
							<p>Notes<span class="d-block"><sub>Input allergies, delivery notes here</sub></span> </p>
						</div>
					</div>
					<div class="mb-1 notes">
						<input type="text" class="form-control form-control1 form-control-sm"  placeholder="" v-model="delivery_notes">
					</div>

				</div><br>

				<!--Address-->
				<div class="container order">
					<h4 class="order-summary">Delivery Address</h4>
				</div>
				<div class="container location"><br>

					<div v-if="address.address_id || address.ga_id">
						<div class="gmap_canvas">
							<iframe class="gmap_iframe" width="100%" height="50%" frameborder="0" scrolling="no" marginheight="0"
								marginwidth="0" :src="getMapUrl()"></iframe >
						</div>

						<div class="">
							<div class="row" style="margin-top: 5px; margin-left: 10px;">
								<div class="col">
									<p class="fw-semibold">{{address.name}}</p>
									<div style="font-weight: bold; margin-bottom: 5px;">{{address.area}}</div>
									<p>{{address.building_no}}/{{address.block_no}},{{address.flat}}, {{address.road_no}} </p>
									<p>+973 {{address.mobile}}</p>
								</div>
								<div class="col">
									<div class="text-end changes" style="margin-right: 8px; margin-top: 5px;">
										<button class="btn btn-warning me btn-sm"  type="button"   @click="chooseAddress()">Change</button>
									</div>
								</div>
							</div>
						</div><br>
					</div>	
					<div v-else>
						<div class="text-end changes" style="margin-right: 10px; margin-bottom: 10px;">
							<span> <button class="btn btn-warning me btn-sm"  type="button"   @click="chooseAddress()">Select Address</button> </span>
						</div>
					</div>	
					
					<!--Address Selection modal-->
					<b-modal ref="address-modal" id="address-modal" hide-footer>
						<div style="margin-left: 10px; margin-right: 10px;">
							<div class="column ">
								<div class="card" v-if="addresses" style="box-shadow: 0px 0px 2px 0px rgba(16, 16, 16, 0.63); background-color: rgb(245, 244, 244);">

									<div class="card-body address" v-for="(address, index) in addresses" :key="index">
										
											<input type="radio" :value="address.address_id" v-model="address_id" name="address">
											{{address.building_no}}, {{address.area}}, {{address.block}}, {{address.flat}}, {{address.landmark}} 
											{{address.road_no}}, Mob:{{address.mobile}} 
									</div>
								</div>
								<div class="card" v-if="guestAddresses" style="box-shadow: 0px 0px 2px 0px rgba(16, 16, 16, 0.63); background-color: rgb(245, 244, 244);">

									<div class="card-body address" v-for="(address, index) in guestAddresses" :key="index">
										
											<input type="radio" :value="address.ga_id" v-model="address_id" name="address">
											{{address.building_no}}, {{address.area}}, {{address.block}}, {{address.flat}}, {{address.landmark}} 
											{{address.road_no}}, Mob:{{address.mobile}} 
									</div>
								</div>
								<div v-else></div><br>
							</div>		
						</div>
						<div class="apply_button">
							<a class="btn checkout"  role="button"  @click="checkAddress(address_id)">Select</a>
						</div>
					</b-modal>

					
					
				</div>
				<div class="form-check no-cultery">
					
					<b-form-checkbox
				      id="chk-contactless"
				      v-model="contactless"
				      name="chk-contactless"
				      value="1"
				      unchecked-value="0"
				      class = "no-cultery"
				      @change="changeContactless()"
				   >
				      
				    <p><strong class="ms-1">Contactless Delivery</strong><br><br><span>Leave order at doorstep and inform me</span> <span class="d-block"><sub class="pt-1" style="line-height: 1.5;">Not applicable with cash payment</sub></span> </p>
				    </b-form-checkbox>				
				</div>

				<!--Delivery type selection-->
				<div class="delivery">
					<h4 class="">Delivery Types</h4><br>					

					<div class=" row">
						<div class="col-xl-3">
							<div class="radio-block m-0 ">
								<div class="radio-outer">
									<input type="radio" name="delivery_type" id="door-delivery" value="DoorDelivery" v-model="delivery_type">
									<label for="door-delivery"></label>
								</div>
								<label>Door delivery</label>
							</div>
						</div>
						<div class="col-xl-3">
							<div class="radio-block m-0 ">
								<div class="radio-outer">
									<input type="radio" name="delivery_type" id="self-pickup"  value="SelfPickup" v-model="delivery_type">
									<label for="self-pickup"></label>
								</div>
								<label>Self Pickup</label>
							</div>
						</div>
					</div>		
				</div><br>

				<!--Payment method-->
				<div class="delivery">
					<h4 class="">Pay With</h4><br>
					<div class="pay pay2">
						<div class="form-check ">
							<div class="radio-block m-0 ">
								<div class="radio-outer">
									<input type="radio" name="payment_method" id="cash"   value="1" unchecked-value="0" v-model="payment_method" @change="changeCash()" :disabled="contactless">
									<label for="cash"></label>
								</div>
								
								<img src="/design/sigofood-images/cash2.png" class="cash-icon">
								<label class="form-check-label ms-1">
									Cash
								</label>
							</div>

						</div>
					</div>

				</div><br>
				<div class="alert alert-warning" role="alert" v-if="contactless==1"> 
					<small>Uncheck contactless delivery to use cash payment</small>
				</div>

				<!--Order summery-->
				<div class="container order">
					<h4 class="order-summary">Payment Summary</h4>
				</div>

				<div class="container payment-summary">
					<div class="row">
						<div class="col-xl">
							<div class="row">
								<div class="col">
									<p class="payment fw-semibold">Subtotal</p>
								</div>
								<div class="col" >
									<p class="payment fw-semibold">BHD {{subtotal}} </p>
								</div>
								
							</div>
							<div class="row">
								<div class="col">
									<p class="payment fw-semibold">Delivery Fee (<small>VAT included</small>)</p>
								</div>
								<div class="col">
									<p class="payment fw-semibold">BHD {{ delivery_charge }}</p>
								</div>
							</div>
							<div class="row">
								<div class="col">
									<p class="fw-semibold total-amount">Total Amount</p>
								</div>
								<div class="col">
									<p class=" fw-semibold total-amount amount">BHD {{parseFloat(delivery_charge)+ parseFloat(subtotal)}}</p>
								</div>
							</div>

						</div>

						<div class="col-xl">
							<p class="fw-semibold total-amount">Schedule</p>
							<div class="row">
								<div class="col">
									<p class="payment fw-semibold">Delivery Date</p>
								</div>
								<div class="col">
									<p class="payment fw-semibold">dd-mm-yyyy</p>
								</div>
							</div>
							<div class="row">
								<div class="col">
									<p class="payment fw-semibold">Delivery Time</p>
								</div>
								<div class="col">
									<p class="payment fw-semibold">within {{ restaurant.delivery_time }} minutes</p>
								</div>
							</div>

						</div>  
					</div><br>

					<div class="row">
						<div class="col-xl-4">
							<div class="d-grid mx-auto" style="margin-bottom: 10px;">
								<button class="btn place-order" type="submit">Place Order</button>
							</div>
						</div>
					</div>

				</div>
			</form>	
		</div>
	</Layout>
</template>


